import React, { FC } from "react";
import { useSelector } from "react-redux";
import { RaceStatusEnum, RaceProgram } from "@tvg/ts-types/Race";
import { TalentPickData } from "@tvg/ts-types/TalentPicks";
import { useTheme } from "@tvg/design-system";
import TalentPicksCard from "../TalentPicksCard";
import CardsLoading from "../CardsLoading";
import {
  CardsPgpContainer,
  ContentContainer,
  TalentPicksContainer,
  TitleContainer
} from "./styled-components";
import useTalentPicks from "../../hooks/useTalentPicks";
import {
  getBlacklistedWagerTypes,
  getTalentPicksSectionTitle,
  getTalentPicksToggleONPgP
} from "../../selectors";
import { filterTalentPicksByBetTypes } from "../../helpers";

interface TalentPickListProps {
  qaLabel?: string;
  raceNumber: string;
  trackCode: string;
  wagerProfile: string;
  races: RaceProgram[];
}

const TalentPickList: FC<TalentPickListProps> = ({
  qaLabel = "talentPicks",
  raceNumber,
  trackCode,
  wagerProfile,
  races
}) => {
  const talentPicksTitle = useSelector(getTalentPicksSectionTitle);
  const talentPicksToggleONPgP = useSelector(getTalentPicksToggleONPgP);
  const { blacklistedBets } = useSelector(getBlacklistedWagerTypes);
  const theme = useTheme();

  const {
    loading,
    talentPicks: { talentPicks }
  } = useTalentPicks({
    raceNumber,
    trackCode,
    wagerProfile,
    races
  });
  if (!talentPicks?.length) {
    return null;
  }

  if (!talentPicksToggleONPgP) {
    return null;
  }

  const talentPicksFiltered = filterTalentPicksByBetTypes(
    talentPicks,
    blacklistedBets
  );

  return (
    <TalentPicksContainer theme={theme} data-qa-label={qaLabel}>
      <TitleContainer theme={theme}>{talentPicksTitle}</TitleContainer>
      <ContentContainer theme={theme}>
        {loading ? (
          <CardsLoading />
        ) : (
          <>
            <CardsPgpContainer
              theme={theme}
              hasMultipleCards={talentPicks?.length > 1}
              data-qa-label={`${qaLabel}-cards-active`}
            >
              {talentPicksFiltered.map(
                (talentPick: TalentPickData, i: number) => {
                  const showBetslipButton = ![
                    RaceStatusEnum.RACE_OFF,
                    RaceStatusEnum.RACE_OFFICIAL
                  ].includes(talentPick.raceStatus);

                  return (
                    <TalentPicksCard
                      key={talentPick.id}
                      talentPick={talentPick}
                      showAddToBetslipButton={showBetslipButton}
                      showViewRaceButton={false}
                      isFDTVPage
                      cardPosition={i}
                    />
                  );
                }
              )}
            </CardsPgpContainer>
          </>
        )}
      </ContentContainer>
    </TalentPicksContainer>
  );
};

export default TalentPickList;
